export enum ScheduleType {
  weekly = 'weekly', // operates on days of week like 'Mon', 'Tue', etc.
  daily = 'daily', // operates on concreate days like '2025-11-23'
}
